import Quality from "../images/creds/Maryland Excels Quality Rating 3.jpg"
import Cred from "../images/creds/Maryland Child Care Credential Level Three.jpg"

export const CredentialList = [
    { 
        name: "Maryland Child Care Credential Level Three", 
        image: Cred
    }, 
    { 
        name: "Maryland EXCELS Quality Rating 3", 
        image: Quality
    }
]